import { IItemWithFinishedItemProfile } from '../../sdk/finished-item-profile/finished-item-profile.types'

export const isQRCodeFilled = (row: IItemWithFinishedItemProfile): boolean => {
  const finishedItemProfile = row.finishedItemProfile
  if (
    !finishedItemProfile ||
    !finishedItemProfile.name ||
    !finishedItemProfile.code ||
    !finishedItemProfile.description ||
    !finishedItemProfile.parts?.length
  ) {
    return false
  }
  for (const p of finishedItemProfile.parts) {
    if (!p.code || !p.name || !p.feedstocks?.length) {
      return false
    }

    for (const f of p.feedstocks) {
      if (!f.code || !f.composition || !f.description || !f.name) {
        return false
      }
    }
  }

  return true
}
